<template>
    <div class="form-check form-check--line-radio js-form-validation__group" :class="className">
        <FormLabel :label="label" :id="id" :required="required" :class="labelClassName"></FormLabel>

        <input class="form-check-input"
               :class="inputClassName"
               @input="$emit('update:checked', $event.target.checked)"
               :value="value"
               :checked="checked"
               type="radio"
               :name="name"
               :required="required"
               :id="id">

        <FormErrors :errors="errors"></FormErrors>
    </div>
</template>

<script setup lang="ts">
// @ts-ignore
import { ref, defineProps, defineEmits } from "vue";
import FormLabel from "../form-elements/includes/FormLabel.vue";
import FormErrors from "../form-elements/includes/FormErrors.vue";

const props = defineProps({
    id: {
        default: null,
        required: true,
        type: String
    },
    type: {
        default: 'text',
        required: false,
        type: String
    },
    required: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        required: true,
    },
    labelClassName: {
        type: String,
        required: false,
        default: null
    },
    inputClassName: {
        type: String,
        required: false,
        default: null
    },
    name: {
        type: String,
        required: true,
    },
    value: {
        type: String,
        required: false,
        default: ""
    },
    checked: {
        type: Boolean,
        required: false,
        default: false
    },
    className: {
        type: String,
        required: false,
        default: null
    }
});
const emit = defineEmits(['update:checked']);

const errors = [];

</script>

